import api from './api';
import { Notification } from '../types';

export const notificationService = {
  async findAll(): Promise<Notification[]> {
    const { data } = await api.get('/notifications');
    return data;
  },

  async getUnreadCount(): Promise<number> {
    const { data } = await api.get('/notifications/unread/count');
    return data;
  },

  async markAsRead(id: string): Promise<Notification> {
    const { data } = await api.patch(`/notifications/${id}/read`);
    return data;
  },

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/mark-all-read');
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/notifications/${id}`);
  },

  async clearAll(): Promise<void> {
    await api.delete('/notifications');
  },
};
